const productGalleryImageCache = new Map();

function preloadProductGalleryImage(src, priority) {
  if (!src) return Promise.resolve(null);
  if (productGalleryImageCache.has(src)) return productGalleryImageCache.get(src);

  const image = new Image();
  image.decoding = 'async';
  if ('fetchPriority' in image) image.fetchPriority = priority || 'auto';

  const ready = new Promise(function(resolve) {
    image.onload = function() {
      const decoded = typeof image.decode === 'function' ? image.decode().catch(function(){}) : Promise.resolve();
      decoded.then(function(){ resolve(image); });
    };
    image.onerror = function(){ resolve(null); };
  });

  productGalleryImageCache.set(src, ready);
  image.src = src;
  return ready;
}

function warmProductGalleries() {
  document.querySelectorAll('[data-th-pdp]').forEach(function(section) {
    const thumbs = Array.from(section.querySelectorAll('[data-th-thumb]'));
    thumbs.forEach(function(thumb, index) {
      if (index < 2) preloadProductGalleryImage(thumb.dataset.src, index === 1 ? 'high' : 'auto');
    });

    const warmRemaining = function() {
      thumbs.slice(2).forEach(function(thumb){ preloadProductGalleryImage(thumb.dataset.src, 'low'); });
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(warmRemaining, { timeout: 1500 });
    else window.setTimeout(warmRemaining, 250);
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', warmProductGalleries, { once: true });
else warmProductGalleries();

document.addEventListener('click', function(event) {
  const thumb = event.target.closest('[data-th-thumb]');
  if (!thumb) return;
  const section = thumb.closest('[data-th-pdp]');
  const main = section && section.querySelector('[data-th-main-image]');
  const targetSrc = thumb.dataset.src;
  if (!main || !targetSrc) return;

  const thumbs = Array.from(section.querySelectorAll('[data-th-thumb]'));
  thumbs.forEach(function(item){ item.setAttribute('aria-current','false'); });
  thumb.setAttribute('aria-current','true');
  const count = section.querySelector('.th-gallery__count');
  if (count) count.textContent = (thumbs.indexOf(thumb) + 1) + ' / ' + thumbs.length;

  preloadProductGalleryImage(targetSrc, 'high').then(function(preloaded) {
    if (!preloaded || thumb.getAttribute('aria-current') !== 'true') return;
    main.removeAttribute('srcset');
    main.src = targetSrc;
    main.alt = thumb.dataset.alt || '';
    main.style.opacity = '1';
  });
});
document.addEventListener('change', function(event) {
  const input = event.target.closest('[data-th-variant]');
  if (!input) return;
  const form=input.closest('form');
  const button=form && form.querySelector('[data-th-add]');
  if (!button) return;
  button.textContent=(input.dataset.available==='true' ? 'Add to bag — ' : 'Sold out — ') + input.dataset.price;
  button.disabled=input.dataset.available!=='true';
});

document.addEventListener('keydown', function(event) {
  const summary = event.target.closest('.chris-th-pdp summary, .chris-th-footer summary');
  if (!summary || (event.key !== 'Enter' && event.key !== ' ')) return;
  event.preventDefault();
  const details = summary.parentElement;
  if (details && details.tagName === 'DETAILS') details.open = !details.open;
});

const touchProductLinkSelector = '.th-use-with__grid a[href], .th-compare__grid a[href]';
let touchProductGesture = null;

document.addEventListener('pointerdown', function(event) {
  if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
  const link = event.target.closest(touchProductLinkSelector);
  if (!link) return;
  touchProductGesture = {
    link: link,
    pointerId: event.pointerId,
    startX: event.clientX,
    startY: event.clientY,
    startScrollX: window.scrollX,
    startScrollY: window.scrollY,
    startedAt: Date.now(),
    moved: false
  };
}, { capture: true, passive: true });

document.addEventListener('pointermove', function(event) {
  if (!touchProductGesture || event.pointerId !== touchProductGesture.pointerId) return;
  const movedBy = Math.hypot(event.clientX - touchProductGesture.startX, event.clientY - touchProductGesture.startY);
  const scrolledBy = Math.hypot(window.scrollX - touchProductGesture.startScrollX, window.scrollY - touchProductGesture.startScrollY);
  if (movedBy > 8 || scrolledBy > 4) touchProductGesture.moved = true;
}, { capture: true, passive: true });

document.addEventListener('pointercancel', function(event) {
  if (!touchProductGesture || event.pointerId !== touchProductGesture.pointerId) return;
  touchProductGesture.moved = true;
}, { capture: true, passive: true });

document.addEventListener('click', function(event) {
  if (!touchProductGesture) return;
  const link = event.target.closest(touchProductLinkSelector);
  if (link !== touchProductGesture.link) return;
  const isDragOrHold = touchProductGesture.moved || Date.now() - touchProductGesture.startedAt > 650;
  touchProductGesture = null;
  if (!isDragOrHold) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}, true);

document.addEventListener('pointerup', function(event) {
  if (!touchProductGesture || event.pointerId !== touchProductGesture.pointerId) return;
  const completedGesture = touchProductGesture;
  window.setTimeout(function() {
    if (touchProductGesture === completedGesture) touchProductGesture = null;
  }, 700);
}, { capture: true, passive: true });
